<template lang="pug">
  b-form-select(
    :value="value"
    :size="size"
    :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
    @input="handleInput"
    )
    option(value="" disabled selected) {{ $t("message.select_option") }}
    option(v-for="option in options" :value="option.value") {{ option.text }}
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "md"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    options: [
      {
        value: "5600",
        text: "Mulan (5600)"
      },
      {
        value: "5500",
        text: "Justice League (5500)"
      }
    ]
  }),
  methods: {
    handleInput(e) {
      this.$emit("input", e);
    }
  }
};
</script>
